import { Injectable } from '@angular/core';

import { RolePermissionViewDoc, rolePermissionViewMethods, rolePermissionViewPullQueryBuilder, rolePermissionViewSchema } from '../schema/role-permission-view-schema';
import { AppState } from '../app-state';

import { TestbedRxdbState } from './testbed-rxdb/testbed-rxdb-state';
import { AuthenticationService } from './authentication.service';
import { TestbedRxdbGraphQlCollectionService } from './testbed-rxdb/testbed-rxdb-graphql-collection.service';
import { map } from 'rxjs/operators';
import { UserRole } from '../models/user';
import { RolePermissionViewRec } from '../models/role-permission-view-rec';


@Injectable({ providedIn: 'root' })
export class RolePermissionViewService extends TestbedRxdbGraphQlCollectionService<RolePermissionViewRec,RolePermissionViewDoc> {

    constructor( appState : AppState, 
            authService: AuthenticationService, 
            rxdbState: TestbedRxdbState ) {
        super('role_permission_view', rolePermissionViewSchema, appState, rxdbState, authService)
        
        this.methods = rolePermissionViewMethods;

        this.syncConfig = {
            push: false,
            pull: true,
            intervalMs: this.appState.settings.get('rxdb.collections.role_permission_view.intervalMs',0),
            retry: true,
            bGraphQL: true,
            query: rolePermissionViewPullQueryBuilder(),
            graphQLSubscription: 
            `subscription{
                rolePermissionViewUpdated{
                    rolePermissionViewRecs{
                        id
                    }
                }
            }`        
        }
    }


    createRoleQuery = () => {
        return this.rxCollection.find().$.pipe( map(this.asUserRoleObjects) )
    }


    asUserRoleObjects = (rolePermissionViewRows) => {
        let rolesById : { [id:string]: UserRole } = {}
        for ( let row of rolePermissionViewRows ) {
            let role = rolesById[row.roleId]
            if ( !role ) {
                role = new UserRole(row.roleId, row.roleName, [row.permissionId])
                rolesById[role.id] = role
            } else {
                role.permissions.push(row.permissionId)
            }
        }
        return Object.values<UserRole>(rolesById)
    }

    async getUserRoles() {
        const rows = await this.rxCollection.find().exec()
        return this.asUserRoleObjects(rows)
    }

    async getUserRole(roleId:string) {
        const rows = await this.rxCollection.find().where('roleId').eq(roleId).exec()
        const roles = this.asUserRoleObjects( rows )
        return roles[0]
    }

}